import { FC } from 'react';

import { useReportPlatformFeedback } from 'src/features/myWork/hooks/useReportPlatformFeedback';
import { IProof } from 'src/ts/interfaces';

import ReportPlatformFeedbackModal from './ReportPlatformFeedbackModal';

type ReportPlatformFeedbackModalContainerProps = {
  entryId: string;
  currentProof?: IProof;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

// Kept apart from the review screen so the store is only read while the flag is on.
const ReportPlatformFeedbackModalContainer: FC<ReportPlatformFeedbackModalContainerProps> = ({
  entryId,
  currentProof,
  showModal,
  setShowModal
}) => {
  const { onReportPlatformFeedback, onFinish, isLoading } = useReportPlatformFeedback();

  return (
    <ReportPlatformFeedbackModal
      showModal={showModal}
      setShowModal={setShowModal}
      isLoading={isLoading}
      // The server rejects a proof from another entry.
      onSubmit={(report) =>
        onReportPlatformFeedback(entryId, {
          ...report,
          proofId: currentProof?.entry_id === entryId ? currentProof.id : undefined
        })
      }
      onConfirmationClosed={onFinish}
    />
  );
};

export default ReportPlatformFeedbackModalContainer;
